import React from "react";
import DefaultHead from "../DefaultHead";

const About: React.FC = () => {
  return (
    <div>
      <DefaultHead />
      <p>
        <iframe
          style={{
            border: "none",
            background: "#eee",
            minWidth: "50%",
            maxWidth: "800px",
            height: "80%",
            minHeight: "600px",
            marginTop: "40px",
            padding: "60px",
          }}
          src="https://app.termly.io/policy-viewer/policy.html?policyUUID=30e4c0a8-9289-4213-abda-3b174d85127b"
        />
      </p>
    </div>
  );
};

export default About;
